// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:17
import { AddressComplementArgs_abstract } from './../abstract/SagaBase/AddressComplementArgs_abstract';
export class AddressComplementArgs extends AddressComplementArgs_abstract {}
